/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import { GatsbyBrowser } from "gatsby";
import React from "react";

// Imported globally because it defines CSS reset on common elements.
import "./src/global.css";

import CustomMDXProvider from "./src/components/CustomMDXProvider";
import Layout from "./src/components/Layout";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = (
  { props, element },
  // _options,
) => <Layout {...props}>{element}</Layout>;

// Strict mode breaks navigation in dev mode; haven't been able to figure out why
// but it doesn't affect produvtion builds
export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = (
  { element },
  // _options,
) => (
  <React.StrictMode>
    <CustomMDXProvider>{element}</CustomMDXProvider>
  </React.StrictMode>
);
